import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import { Assignment, Business, EmojiEvents, FitnessCenter, FormatQuote, Group, Home, MenuBook, Payment, Restaurant, SupportAgent } from '@mui/icons-material';
import {
  AccountBoxMultiple,
  CalendarCursor,
  ChartBoxOutline,
  ClipboardList,
  NewspaperVariantOutline,
  TableSearch,
  WeightLifter
} from 'mdi-material-ui';
import CollapsibleMenuItem from 'components/shared/menus/CollapsibleMenuItem';
import MenuItem from 'components/shared/menus/MenuItem';
import NestedMenuItem from 'components/shared/menus/NestedMenuItem';
import routes from 'common/routes';
import SidebarPanelContext from 'context/SidebarPanelContext';

function AdminDesktopMenu() {
  const { t } = useTranslation(['routes', 'pqrs']);
  // Rail colapsado: lo decide el panel host (desktop mini / mobile expandido).
  const { iconOnly: shouldUseIconOnly } = useContext(SidebarPanelContext);

  return (
    <List>
      <MenuItem
        icon={<Home />}
        iconOnly={shouldUseIconOnly}
        itemKey="home"
        label={t('home', { ns: 'routes' })}
        path={routes.adminDashboard.path}
      />
      <MenuItem
        icon={<NewspaperVariantOutline />}
        iconOnly={shouldUseIconOnly}
        itemKey="news"
        label={t('news.list', { ns: 'routes' })}
        path={routes.listNews.path}
      />
      <MenuItem
        icon={<CalendarCursor />}
        iconOnly={shouldUseIconOnly}
        itemKey="calendar"
        label={t('session.calendar', { ns: 'routes' })}
        path={routes.calendar.path}
      />
      <MenuItem
        icon={<TableSearch />}
        iconOnly={shouldUseIconOnly}
        itemKey="sessions"
        label={t('session.list', { ns: 'routes' })}
        notMatchPath={routes.groupSessions.path}
        path={routes.listSession.path}
      />
      <MenuItem
        icon={<Group />}
        iconOnly={shouldUseIconOnly}
        itemKey="groupSessions"
        label={t('session.groupSessions', { ns: 'routes' })}
        path={routes.groupSessions.path}
      />
      <MenuItem
        icon={<WeightLifter />}
        iconOnly={shouldUseIconOnly}
        itemKey="sessionTypes"
        label={t('sessionType.list', { ns: 'routes' })}
        path={routes.listSessionType.path}
      />
      <CollapsibleMenuItem
        icon={<ClipboardList />}
        iconOnly={shouldUseIconOnly}
        label={t('plan.list', { ns: 'routes' })}
        noLink>
        <NestedMenuItem
          label={t('plan.list', { ns: 'routes' })}
          path={routes.listPlan.path}
        />
        <NestedMenuItem
          label={t('plan.requests', { ns: 'routes' })}
          path={routes.planRequests.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<MenuBook />}
        iconOnly={shouldUseIconOnly}
        itemKey="nutrition"
        label={t('mealPlan.list', { ns: 'routes' })}
        path={routes.listMealPlan.path}
      />
      <CollapsibleMenuItem
        icon={<FitnessCenter />}
        iconOnly={shouldUseIconOnly}
        label={t('exercise.exercises', { ns: 'routes' })}
        noLink>
        <NestedMenuItem
          end
          label={t('exercise.list', { ns: 'routes' })}
          path={routes.exercises.path}
        />
        <NestedMenuItem
          label={t('play.exercisesAdmin', { ns: 'routes', defaultValue: 'Ejercicios Play' })}
          path={routes.exercisesPlay.path}
        />
        <NestedMenuItem
          label={t('exercise.requests', { ns: 'routes' })}
          path={routes.exerciseRequests.path}
        />
        <NestedMenuItem
          label={t('play.moderation', { ns: 'routes', defaultValue: 'Moderación OTRIX Play' })}
          path={routes.playModeration.path}
        />
        <NestedMenuItem
          label={t('play.musicAdmin', { ns: 'routes', defaultValue: 'Música Play' })}
          path={routes.playMusicAdmin.path}
        />
        <NestedMenuItem
          label={t('play.recoveryAdmin', { ns: 'routes', defaultValue: 'Prácticas de descanso' })}
          path={routes.playRecoveryAdmin.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<ChartBoxOutline />}
        iconOnly={shouldUseIconOnly}
        itemKey="performance"
        label={t('performance.list', { ns: 'routes' })}
        path={routes.listPerformance.path}
      />
      <MenuItem
        icon={<AccountBoxMultiple />}
        iconOnly={shouldUseIconOnly}
        itemKey="progress"
        label={t('progress.list', { ns: 'routes' })}
        path={routes.listProgress.path}
      />
      <MenuItem
        icon={<EmojiEvents />}
        iconOnly={shouldUseIconOnly}
        itemKey="ranking"
        label={t('gamification.globalRanking', { ns: 'routes' })}
        path={routes.globalRanking.path}
      />
      <MenuItem
        icon={<Restaurant />}
        iconOnly={shouldUseIconOnly}
        itemKey="nutrition-admin"
        label={t('nutrition', { ns: 'routes', defaultValue: 'Nutrición' })}
        path={routes.adminNutrition.path}
      />
      <MenuItem
        icon={<FormatQuote />}
        iconOnly={shouldUseIconOnly}
        itemKey="motivational-phrases"
        label={t('motivationalPhrases', { ns: 'routes', defaultValue: 'Frases motivacionales' })}
        path={routes.adminMotivationalPhrases.path}
      />
      <CollapsibleMenuItem
        icon={<Payment />}
        iconOnly={shouldUseIconOnly}
        label={t('payment.payments', { ns: 'routes' })}
        noLink>
        <NestedMenuItem
          label={t('payment.summary', { ns: 'routes' })}
          path={routes.payments.path}
        />
        <NestedMenuItem
          label={t('client.list', { ns: 'routes' })}
          path={routes.listClientPayments.administrator.path}
        />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainerPayments.administrator.path}
        />
        <NestedMenuItem
          label="Suscriptores"
          path={routes.adminSubscriptions.path}
        />
        <NestedMenuItem
          label={t('coupons', { ns: 'routes', defaultValue: 'Cupones' })}
          path={routes.adminCoupons.path}
        />
        <NestedMenuItem
          label={t('billingInfo', { ns: 'routes', defaultValue: 'Datos de facturación' })}
          path={routes.billingInfo.path}
        />
      </CollapsibleMenuItem>
      <CollapsibleMenuItem
        icon={<Group />}
        iconOnly={shouldUseIconOnly}
        label={t('users', { ns: 'routes' })}
        noLink
        path={routes.users.path}>
        <NestedMenuItem
          label={t('administrator.list', { ns: 'routes' })}
          path={routes.listAdmin.path}
        />
        <NestedMenuItem
          label={t('supervisor.list', { ns: 'routes' })}
          path={routes.listSupervisor.path}
        />
        <NestedMenuItem label={t('client.list', { ns: 'routes' })} path={routes.listClient.path} />
        <NestedMenuItem
          label={t('trainer.list', { ns: 'routes' })}
          path={routes.listTrainer.path}
        />
        <NestedMenuItem
          label={t('orgManagers', { ns: 'routes', defaultValue: 'Prometeo' })}
          path={routes.adminOrgManagers.path}
        />
      </CollapsibleMenuItem>
      <MenuItem
        icon={<Business />}
        iconOnly={shouldUseIconOnly}
        itemKey="organizations"
        label={t('organizations', { ns: 'routes', defaultValue: 'Organizaciones' })}
        path={routes.adminOrganizations.path}
      />
      <MenuItem
        icon={<Assignment />}
        iconOnly={shouldUseIconOnly}
        itemKey="legal"
        label={t('legal.list', { ns: 'routes' })}
        path={routes.listLegal.path}
      />
      <MenuItem
        icon={<SupportAgent />}
        iconOnly={shouldUseIconOnly}
        itemKey="pqrs"
        label={t('title', { ns: 'pqrs', defaultValue: 'PQRS' })}
        path={routes.adminPqrs.path}
      />
    </List>
  );
}

export default AdminDesktopMenu;
